export type StatTone = "primary" | "secondary" | "accent" | "neutral";

export interface StatItem {
  label: string;
  value: string;
  icon: string;
  tone: StatTone;
}

const TONES: Record<StatTone, string> = {
  primary: "bg-primary-100 text-primary-600",
  secondary: "bg-secondary-100 text-secondary-600",
  accent: "bg-accent-100 text-accent-700",
  neutral: "bg-background-100 text-foreground-500",
};

interface StatsCardsProps {
  stats: StatItem[];
}

export default function StatsCards({ stats }: StatsCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="rounded-lg border border-background-200/70 bg-background-50 p-5"
        >
          <span
            className={`mb-3 flex h-10 w-10 items-center justify-center rounded-md ${TONES[stat.tone]}`}
          >
            <i className={`${stat.icon} text-lg`}></i>
          </span>
          <p className="font-heading text-2xl font-bold text-foreground-950">
            {stat.value}
          </p>
          <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}